import React from "react";
import { Reveal } from "../lib/anim";

const SECTORS = [
  { name: "Immobilier", text: "Résidences, biens d'exception et programmes sublimés par l'image." },
  { name: "Commerces de proximité", text: "Boutiques, artisans et petites entreprises mis en valeur avec émotion." },
  { name: "Boutiques de luxe & premium", text: "Maisons de couture, concept stores et univers haut de gamme." },
  { name: "Concessions automobiles", text: "Véhicules et marques automobiles mis en scène avec caractère." },
  { name: "Hôtels, restaurants & hospitalité", text: "Établissements et expériences racontés avec élégance." },
  { name: "Communication de marque & corporate", text: "Films institutionnels et campagnes immersives à forte valeur." },
];

const Sectors = () => (
  <section id="secteurs" data-testid="sectors-section" className="py-24 lg:py-40 border-t border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="mb-16 max-w-2xl">
        <Reveal><p className="eyebrow mb-6">Secteurs d'activité</p></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F5F5F0]">
            Des univers que nous <span className="italic gold-text">sublimons</span>.
          </h2>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {SECTORS.map((s, i) => (
          <Reveal key={s.name} delay={i * 0.06}>
            <div data-testid={`sector-${i}`} className="group h-full bg-[#050505] p-8 lg:p-10 hover:bg-[#0d0d0d] transition-colors duration-500">
              <span className="font-serif text-3xl text-[#D4AF37]/40 group-hover:text-[#D4AF37] transition-colors duration-500">0{i + 1}</span>
              <h3 className="font-serif text-2xl lg:text-3xl text-[#F5F5F0] mt-4">{s.name}</h3>
              <p className="text-[#A1A1AA] leading-relaxed mt-3 text-sm">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Sectors;
